<template>
  <div class="activiteVignette card mt-3" @click.prevent="onVignetteClick">
    <img v-if="activity.vignette && activity.vignette.media" :alt="activity.vignette.media.alt"
         :src="widgetURL + activity.vignette.media.url" class="card-img-top">

    <div class="card-body">
      <ActivityInfos :activity="activity" show-title="true" :catalogueTraduction="catalogueTraduction"/>

      <div class="bouton d-grid gap-1">
        <template v-if="activity.site">
          <a :href="activity.site" target="_blank" class="btn btn-lg btn-aller">{{activity.nomButton}}</a>
        </template>
        <template v-else>
          <router-link
              :to="{ name: 'Activity', query: { catalogue : idCatalogue, activity : activity.id}}"
              class="btn btn-lg btn-info" >
            {{ catalogueTraduction?.catalogueBtnVoirActivite || $t('catalogue.btnVoirActivite') }}
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants";
import router from "@/router";
import {formatPrice} from "@/utils";
import ActivityInfos from "@/components/ActivityInfos";

export default {
  name: 'Vignette',
  props: ['activity', 'idCatalogue', 'catalogueTraduction'],
  components: {ActivityInfos},
  setup(props) {
    const widgetURL = process.env.VUE_APP_WIDGET_API_SERVER;

    if (!props.activity || !props.idCatalogue)
      console.error('missing props');

    const onVignetteClick = () => {
      if(props.activity.site != null) {
        window.open(props.activity.site, '_blank');
      }else {
        router.push({name: 'Activity', query: {catalogue: props.idCatalogue, activity: props.activity.id}});
      }
    }

    return {widgetURL, constants, onVignetteClick, formatPrice};
  },
  computed: {
    getLibelleForPrice() {
      if (this.activity.periodes[0].nbJours < 4)
        return this.catalogueTraduction?.activityPrixJour || 'jour';
      else if (this.activity.periodes[0].nbJours >= 4 && this.activity.periodes[0].nbJours <= 7)
        return this.catalogueTraduction?.activityPrixSemaine || 'semaine';
      else
        return this.catalogueTraduction?.activityPrixQuinzaine || 'quinzaine';
    }
  }
}
</script>

<style scoped>
.activiteVignette :hover {
  cursor: pointer;
}

ul .no-bullets {
  list-style-type: none;
}
</style>
